import { DragIndicatorStyle } from '@/data/hook/shared/dnd/useDragPlaceholder';

export type DragIndicatorProps = {
  style?: DragIndicatorStyle;
};

const DragIndicator: React.FC<DragIndicatorProps> = ({ style }) => (
  <div
    className="absolute pointer-events-none border border-dashed border-primary/40 bg-primary/5 rounded-2xl transition-[top] duration-200"
    style={{
      top: style?.top,
      left: 0,
      height: style?.height,
      width: style?.width,
    }}
  />
);

export default DragIndicator;
